import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

const baseUrl = process.env.VUE_APP_API_BASE;
axios.defaults.baseURL = baseUrl;

Vue.use(VueAxios, axios);

// Interceptor para agregar el token en cada request
axios.interceptors.request.use(
  async config => {
    const authToken = localStorage.getItem("auth_token");
    const loginMethod = localStorage.getItem("login_method");

    // No enviar token en endpoints de autenticación (login, forgot, reset)
    const authEndpoints = ['/login_bice', '/forgot-password', '/reset-password'];
    const isAuthEndpoint = authEndpoints.some(endpoint => config.url?.includes(endpoint));

    if (authToken && !isAuthEndpoint) {
      if (loginMethod === "bice") {
        // Para login Bice, usar formato Bearer
        config.headers.Authorization = `Bearer ${authToken}`;
      } else {
        // Para login Azure, usar el token directamente
        config.headers.Authorization = authToken;
      }
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de autenticación
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // No redirigir si el error viene de endpoints de autenticación
      // Esto permite que los componentes de login manejen sus propios errores
      const authEndpoints = ['/login_standard', '/forgot-password', '/reset-password'];
      const isAuthEndpoint = authEndpoints.some(endpoint =>
        error.config?.url?.includes(endpoint)
      );

      if (isAuthEndpoint) {
        // Dejar que el componente maneje el error
        return Promise.reject(error);
      }

      const loginMethod = localStorage.getItem("login_method");

      if (loginMethod === "bice") {
        // Si el token JWT expiró, redirigir a Azure (flujo normal)
        console.warn("Token JWT expirado, redirigiendo a Azure");
        localStorage.removeItem("auth_token");
        localStorage.removeItem("login_method");
        localStorage.removeItem("uid");
        window.location.href = process.env.VUE_APP_API_URL + "/azure_auth";
      } else {
        // Si es Azure, redirigir a Azure auth
        console.warn("Token Azure expirado, redirigiendo a Azure");
        localStorage.removeItem("auth_token");
        localStorage.removeItem("cod");
        localStorage.removeItem("uid");
        window.location.href = process.env.VUE_APP_API_URL + "/azure_auth";
      }
    }

    return Promise.reject(error);
  }
);